export default "__VITE_ASSET__e7a2720e__"